import React from "react";
import { Modal } from "antd";
import { UserProfile } from "@clerk/clerk-react";
import styles from "./SecurityModal.module.css";

const CLERK_APPEARANCE = {
  variables: {
    colorPrimary: "#8B5CF6",
    colorPrimaryForeground: "#FFFFFF",
    colorBackground: "#0B0F1A",
    colorForeground: "#E7EAF3",
    colorMutedForeground: "rgba(231, 234, 243, 0.6)",
    colorMuted: "rgba(17, 19, 30, 0.8)",
    colorInput: "rgba(17, 19, 30, 0.85)",
    colorInputForeground: "#E7EAF3",
    colorBorder: "rgba(255, 255, 255, 0.1)",
    colorRing: "rgba(139, 92, 246, 0.6)",
    borderRadius: "16px",
  },
  elements: {
    rootBox: { width: "100%", maxHeight: "100%" },
    card: { backgroundColor: "transparent", boxShadow: "none" },
    navbar: { backgroundColor: "transparent" },
    pageScrollBox: { backgroundColor: "transparent" },
  },
};

export default function SecurityModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={920}
      centered
      destroyOnClose
      wrapClassName={styles.wrap}
      className={styles.modal}
      styles={{ body: { padding: 0 } }}
      getContainer={false}
    >
      <div className={styles.inner}>
        <UserProfile appearance={CLERK_APPEARANCE} />
      </div>
    </Modal>
  );
}
